import type { SponsoredAdSlot } from "../ecommersProduct/types";

export type AdPlacement =
  | "search"
  | "home_feed"
  | "category_page"
  | "product_page";

export type AdType = "product" | "sponsored_brand" | "display";

export interface PlacementSlots {
  placement: AdPlacement;
  slots: SponsoredAdSlot[];
}

export interface FetchAdSlotsParams {
  placement: AdPlacement;
  city?: string;
  pincode?: string;
  sessionId?: string;
  userId?: string;
  searchQuery?: string;
  categoryType?: string;
  productId?: string;
  adTypes?: AdType[];
  limit?: number;
}

export interface FetchAdSlotsBatchParams {
  city?: string;
  pincode?: string;
  sessionId?: string;
  userId?: string;
  placements: Array<{
    placement: AdPlacement;
    adTypes?: AdType[];
    limit?: number;
    searchQuery?: string;
    categoryType?: string;
    productId?: string;
  }>;
}

export interface StorefrontAdsState {
  slotsByPlacement: Partial<Record<AdPlacement, SponsoredAdSlot[]>>;
  loading: Partial<Record<AdPlacement, boolean>>;
  error: string | null;
}

export const STOREFRONT_ADS_ACTION_TYPES = {
  FETCH_SLOTS: "storefrontAds/fetchSlots",
  FETCH_SLOTS_BATCH: "storefrontAds/fetchSlotsBatch",
} as const;
